import { Flag, Star } from 'lucide-react';

export const getOrderContextMenuItems = ({ row, isStaffUser, onPin, onRush }) => {
  if (!isStaffUser) return [];

  const isRush = Boolean(row?.rush);

  return [
    {
      key: 'pin',
      label: row?.pinned ? 'Unpin order' : 'Pin order',
      icon: Star,
      action: onPin,
      variant: 'default'
    },
    {
      key: 'rush',
      label: isRush ? 'Already marked as rush' : 'Make this rush',
      icon: Flag,
      disabled: isRush,
      action: onRush,
      variant: 'danger'
    }
  ];
};
